import {computed, inject, unref} from "vue";

// The provide/inject key HomePage's SectionHeadingLevel uses (the level is 1 or 2).
export const SECTION_HEADING_LEVEL = "sectionHeadingLevel";

// The tag for a section's MAIN heading: 'h1' for the one section that carries the page's H1, otherwise 'h2'. Outside a
// wrapper (the shop, previews) it is always 'h2'. A frame that draws its title as a div or span passes that as `plain`
// and gets it back unless it is the H1.
export function useSectionHeadingTag(plain = "h2") {
    const level = inject(SECTION_HEADING_LEVEL, 2);
    return computed(() => (unref(level) === 1 ? "h1" : plain));
}
